var render, staticRenderFns
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3404148957/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/685534022793/ap-northeast-1/f1302ef0-e4fb-4a64-823b-3e21860016cb/lvgs/project-LPNUT/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c479e4')) {
      api.createRecord('69c479e4', component.options)
    } else {
      api.reload('69c479e4', component.options)
    }
    
  }
}
component.options.__file = "resources/views/common/object/component/form/elementLp1/followup/component.vue"
export default component.exports